import { Action } from '@ngrx/store';


export enum MainLoadActionTypes {
  ACTIVE_MAIN_LOAD = '[MAIN] ActiveLoad',
  DEACTIVE_MAIN_LOAD = '[MAIN] DeactiveLoad'
}

export class MainLoadActive implements Action {
  readonly type = MainLoadActionTypes.ACTIVE_MAIN_LOAD;
  constructor() {}
}

export class MainLoadDeactive implements Action {
  readonly type = MainLoadActionTypes.DEACTIVE_MAIN_LOAD;
  constructor() {}
}

export type MainLoadAcciones =
    | MainLoadActive
    | MainLoadDeactive;
